import React from "react"
import { useTranslation } from "react-i18next"

import { PriceTag } from "widgets/price-tag/PriceTag"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"
import { useProductPositionFormPriceContext } from "../../contexts/ProductPositionFormPriceContext"

export const ProductPositionTotalPrice = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, formOptions } = useProductPositionFormCoreContext()
  const { isLoading, isLoadingPrice } = useProductPositionFormLoadingContext()
  const { price, isPriceServiceAvailable } =
    useProductPositionFormPriceContext()
  const { hidePrice, hidePriceTotal, isPriceReadonly } = formOptions || {}

  const showPriceTotal =
    !hidePrice && (isReadonly || isPriceReadonly) && !hidePriceTotal

  if (!showPriceTotal) return null

  return (
    <PriceTag
      className="product-position-form__price-total"
      price={price?.priceTotal}
      currency={price?.currency}
      isComplete={price?.isComplete}
      label={t("Price.TotalPrice")}
      isPriceServiceAvailable={isPriceServiceAvailable}
      isLoading={isLoading || isLoadingPrice}
    />
  )
})
